module.exports = __webpack_public_path__ + "img/ellipse28.d98812c9.png";